import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack'; // Asegúrate de importar correctamente este hook
import useStateHandler from '@/hooks/useStateHandler';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import { editArtwork as editArtworkHandler } from '@/shared-components/forms/add-artwork/submit-button/components/EditArtworkHandler';
import { validateArtworkFields } from '@/shared-components/forms/add-artwork/utils';

import './styles/EditArtwork.css';

export default function EditArtwork({ formState, setFormError }) {
  const { cacheHandler, stateHandler } = useStateHandler();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const goBackHandler = useGoBack("/");

  const validations = () => {
    setLoading(true);
    setFormError(null);
    const errors = validateArtworkFields(formState);
    if (errors.length > 0) {
      setFormError(errors);
      setLoading(false);
      return false;
    }
    return true;
  };

  async function editArtwork(event) {
    // we prevent the normal behavior
    // on submiting to not show the alert of the browser
    event.preventDefault();
    if (!validations()) return;
    setLoading(true);
    setFormError(null);
    
    await editArtworkHandler({
      formState,
      setFormError,
      navigate,
      cacheHandler,
      goBackHandler,
      onArtworkEdited: () => {
        stateHandler.set("temporalPopup", {
          text: "Artwork edited successfully!",
          type: "navbar-present",
        });
      },
    });
    
    setLoading(false);
  }

  return (
    <ContinueButton 
      onClick={editArtwork} 
      medium
      disabled={loading}
      loading={loading}
    >
      Confirm Changes
    </ContinueButton>
  );
}
